module.exports = __webpack_public_path__ + "img/AISpace2.70576a4d.jpg";